import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const courseOptions = ['A Letter From ADRE', 'Are They Represented?', 'Avoid The Oops: Contract Smarts for Agents', 'BMC #1 AZ Residential-Statutes and Rules', 'BMC #2 AZ Residential-Broker Policies', 'BMC #3 AZ Residential-Broker Supervision', 'BMC #3B Property Management', "Don't Lose Your License", 'Ethics & The Rules (with NAR Code of Ethics)', "Fair Housing In Today's World", 'Follow All The Laws', 'Mastering Agency Agreements', 'NAR Code of Ethics (NO CE CREDIT)', 'No Secrets', 'The Bottom Line of Disclosure', 'They Are A Protected Class', 'What Goes Wrong In Contracts', 'Your Clients Are Not Mushrooms'];
export function SwitchExpiredClass() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2333">
      <div className="flex items-center justify-between" data-id="element-2334">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2335">
          Switch Expired Class
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-2336">
          ← Back to Admin Area
        </Button>
      </div>

      <Card data-id="element-2337">
        <CardContent className="pt-6" data-id="element-2338">
          <form className="space-y-4" data-id="element-2339">
            <div className="flex items-center gap-3" data-id="element-2340">
              <label className="text-sm font-medium text-slate-700 w-20" data-id="element-2341">
                Old Class:
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[260px]" data-id="element-2342">
                {courseOptions.map(c => <option key={c} data-id="element-2343">{c}</option>)}
              </select>
            </div>
            <div className="flex items-center gap-3" data-id="element-2344">
              <label className="text-sm font-medium text-slate-700 w-20" data-id="element-2345">
                New Class:
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[260px]" data-id="element-2346">
                {courseOptions.map(c => <option key={c} data-id="element-2347">{c}</option>)}
              </select>
            </div>
            <div className="pt-1" data-id="element-2348">
              <Button type="submit" data-id="element-2349">Apply</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}